import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../utils/firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, collection, query, where, orderBy, getDocs, deleteDoc } from "firebase/firestore";
import { useCarrito } from "../context/CarritoContext";
import toast from "react-hot-toast";
import { FiRotateCw, FiShoppingCart } from "react-icons/fi";

export default function RepetirPedido() {
  const [user, setUser] = useState(null);
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { agregarAlCarrito, carrito } = useCarrito();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (usuarioActual) => {
      if (!usuarioActual) {
        toast.error("Debes iniciar sesión para ver pedidos anteriores");
        navigate("/");
        return;
      }
      setUser(usuarioActual);
      cargarPedidos(usuarioActual.uid);
    });

    return () => unsubscribe();
  }, [navigate]);

  const cargarPedidos = async (userId) => {
    try {
      setLoading(true);
      const q = query(
        collection(db, "pedidos"),
        where("userId", "==", userId),
        orderBy("fecha", "desc")
      );
      
      const querySnapshot = await getDocs(q);
      const pedidosData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        fecha: doc.data().fecha?.toDate()
      }));
      
      setPedidos(pedidosData);
    } catch (err) {
      console.error("Error cargando pedidos:", err);
      toast.error("No se pudieron cargar tus pedidos anteriores");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteOrder = async (orderId) => {
    try {
      await deleteDoc(doc(db, "pedidos", orderId));
      // Filtramos el pedido borrado de la lista
      setPedidos(prev => prev.filter(p => p.id !== orderId));
      toast.success("Pedido eliminado");
    } catch (error) {
      console.error("Error eliminando pedido:", error);
      toast.error("No se pudo eliminar el pedido");
    }
  };

  const repetirPedido = async (productos) => {
    if (!user) {
      toast.error("Debes iniciar sesión para realizar esta acción");
      return;
    }

    try {
      // Verificar stock antes de agregar


      // Agregar productos al carrito
      productos.forEach((item) => {
        agregarAlCarrito({
          id: item.id,
          nombre: item.nombre,
          cantidad: item.cantidad,
          img: item.img || "",
          categoria: item.categoria || "",
          sku: item.sku || item.id
        });
      });

      toast.success("Productos agregados al carrito correctamente", {
        icon: <FiShoppingCart className="text-green-500" />
      });
    } catch (error) {
      console.error("Error al repetir pedido:", error);
      toast.error("Error al agregar productos al carrito");
    }
  };

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="animate-pulse flex flex-col gap-4">
          <div className="h-8 bg-gray-200 rounded w-1/3"></div>
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-24 bg-gray-100 rounded"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-4 md:p-6">
      <div className="mb-4 text-sm text-gray-600">
        <button
          onClick={() => navigate("/")}
          className="text-empresarialDark hover:underline"
        >
          Inicio
        </button>
        <span className="mx-2 text-gray-400">/</span>
        <span className="text-gray-800 font-medium">Repetir pedido</span>
      </div>
      <h2 className="text-2xl font-bold text-empresarialDark mb-6">Tus Pedidos Anteriores</h2>

      {pedidos.length === 0 ? (
        <div className="bg-white p-6 rounded-lg shadow-sm text-center border border-gray-100">
          <p className="text-gray-500">No hay pedidos anteriores registrados</p>
        </div>
      ) : (
        <div className="space-y-4">
          {pedidos.map((pedido) => (
            <div key={pedido.id} className="bg-white p-5 rounded-lg shadow-sm border border-gray-100">
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h3 className="font-semibold text-empresarial">Pedido #{pedido.id.slice(0, 8).toUpperCase()}</h3>
                  <p className="text-sm text-gray-500">
                    {pedido.fecha?.toLocaleDateString()} - {pedido.fecha?.toLocaleTimeString()}
                  </p>
                </div>
              </div>
              
              <div className="border-t pt-3">
                {pedido.productos.map((prod, i) => (
                  <div key={i} className="flex justify-between text-sm py-1">
                    <span className="text-gray-700">{prod.nombre}</span>
                    <span className="text-gray-500">x{prod.cantidad}</span>
                  </div>
                ))}
              </div>

              <div className="mt-4 flex justify-end, gap-2">
                <button
                  onClick={() => repetirPedido(pedido.productos)}
                  className="flex items-center gap-2 px-4 py-2 bg-empresarial hover:bg-empresarialDark text-white rounded-lg transition-colors"
                >
                  <FiRotateCw />
                  <span>Pedir de nuevo</span>
                </button>

                <button
                  onClick={() => handleDeleteOrder(pedido.id)}
                  className="px-4 py-2 text-red-500 hover:text-red-700 text-sm rounded-lg border border-red-200"
                >
                  Eliminar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

